/* eslint-disable multiline-comment-style */
import Color from '@bubble-dev/fantasy-color';
import { createConstantColorDeprecated } from './helpers';
var deprecation = {
  removalDate: 'v5.0.0'
}; // These brand colors might be out of date and are therefore deprecated

/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor106 = createConstantColorDeprecated('brandColor106', deprecation, new Color('#FFB3C7'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor106Hovered = createConstantColorDeprecated('brandColor106Hovered', deprecation, new Color('#F3ACB7'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor106Pressed = createConstantColorDeprecated('brandColor106Pressed', deprecation, new Color('#F09EA9'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor102 = createConstantColorDeprecated('brandColor102', deprecation, new Color('#5C4144'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor102Hovered = createConstantColorDeprecated('brandColor102Hovered', deprecation, new Color('#53393C'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor102Pressed = createConstantColorDeprecated('brandColor102Pressed', deprecation, new Color('#4A3234'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor206 = createConstantColorDeprecated('brandColor206', deprecation, new Color('#EFCAC8'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor206Hovered = createConstantColorDeprecated('brandColor206Hovered', deprecation, new Color('#F1D0CE'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor206Pressed = createConstantColorDeprecated('brandColor206Pressed', deprecation, new Color('#EDC5C3'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor203 = createConstantColorDeprecated('brandColor203', deprecation, new Color('#6B5353'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor203Hovered = createConstantColorDeprecated('brandColor203Hovered', deprecation, new Color('#614A4A'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor203Pressed = createConstantColorDeprecated('brandColor203Pressed', deprecation, new Color('#584242'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor202 = createConstantColorDeprecated('brandColor202', deprecation, new Color('#564242'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor202Hovered = createConstantColorDeprecated('brandColor202Hovered', deprecation, new Color('#4D3A3A'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor202Pressed = createConstantColorDeprecated('brandColor202Pressed', deprecation, new Color('#443333'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor204 = createConstantColorDeprecated('brandColor204', deprecation, new Color('#8B6867'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor306 = createConstantColorDeprecated('brandColor306', deprecation, new Color('#D7BBD4'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor306Hovered = createConstantColorDeprecated('brandColor306Hovered', deprecation, new Color('#DCC2D9'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor306Pressed = createConstantColorDeprecated('brandColor306Pressed', deprecation, new Color('#D3B6D0'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor303 = createConstantColorDeprecated('brandColor303', deprecation, new Color('#725E69'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor303Hovered = createConstantColorDeprecated('brandColor303Hovered', deprecation, new Color('#68555F'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor303Pressed = createConstantColorDeprecated('brandColor303Pressed', deprecation, new Color('#5F4C56'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor302 = createConstantColorDeprecated('brandColor302', deprecation, new Color('#51444E'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor302Hovered = createConstantColorDeprecated('brandColor302Hovered', deprecation, new Color('#483C45'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor302Pressed = createConstantColorDeprecated('brandColor302Pressed', deprecation, new Color('#40343D'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor406 = createConstantColorDeprecated('brandColor406', deprecation, new Color('#BCD5D3'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor406Hovered = createConstantColorDeprecated('brandColor406Hovered', deprecation, new Color('#C3DAD8'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor406Pressed = createConstantColorDeprecated('brandColor406Pressed', deprecation, new Color('#B7D1CF'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor403 = createConstantColorDeprecated('brandColor403', deprecation, new Color('#5A6866'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor403Hovered = createConstantColorDeprecated('brandColor403Hovered', deprecation, new Color('#515E5C'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor403Pressed = createConstantColorDeprecated('brandColor403Pressed', deprecation, new Color('#485553'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor402 = createConstantColorDeprecated('brandColor402', deprecation, new Color('#424C4A'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor402Hovered = createConstantColorDeprecated('brandColor402Hovered', deprecation, new Color('#3A4341'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor402Pressed = createConstantColorDeprecated('brandColor402Pressed', deprecation, new Color('#333C3A'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor404 = createConstantColorDeprecated('brandColor404', deprecation, new Color('#788C8A'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor504 = createConstantColorDeprecated('brandColor504', deprecation, new Color('#868274'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor506 = createConstantColorDeprecated('brandColor506', deprecation, new Color('#D2CBBB'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor506Hovered = createConstantColorDeprecated('brandColor506Hovered', deprecation, new Color('#D7D1C2'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor506Pressed = createConstantColorDeprecated('brandColor506Pressed', deprecation, new Color('#CEC6B5'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor502 = createConstantColorDeprecated('brandColor502', deprecation, new Color('#3F443E'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor502Hovered = createConstantColorDeprecated('brandColor502Hovered', deprecation, new Color('#373C37'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor502Pressed = createConstantColorDeprecated('brandColor502Pressed', deprecation, new Color('#30342F'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor503 = createConstantColorDeprecated('brandColor503', deprecation, new Color('#68645B'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor503Hovered = createConstantColorDeprecated('brandColor503Hovered', deprecation, new Color('#5E5A52'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor503Pressed = createConstantColorDeprecated('brandColor503Pressed', deprecation, new Color('#555149'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor602 = createConstantColorDeprecated('brandColor602', deprecation, new Color('#40494C'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor606 = createConstantColorDeprecated('brandColor606', deprecation, new Color('#B2CED7'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor606Hovered = createConstantColorDeprecated('brandColor606Hovered', deprecation, new Color('#C1DBE4'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor606Pressed = createConstantColorDeprecated('brandColor606Pressed', deprecation, new Color('#A4C1CA'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor706 = createConstantColorDeprecated('brandColor706', deprecation, new Color('#D0DDBB'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor706Hovered = createConstantColorDeprecated('brandColor706Hovered', deprecation, new Color('#DAE8C6'));
/**
 * used in contrib
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor706Pressed = createConstantColorDeprecated('brandColor706Pressed', deprecation, new Color('#B4C59C'));
/**
 * used in icon-colors
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor702 = createConstantColorDeprecated('brandColor702', deprecation, new Color('#3D4336'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor702Hovered = createConstantColorDeprecated('brandColor702Hovered', deprecation, new Color('#464D3F'));
/**
 * not used?
 * @deprecated this brand color is outdated and will be removed with v5.0.0, please update to another brand color or use a color variable instead
 */

export var brandColor702Pressed = createConstantColorDeprecated('brandColor702Pressed', deprecation, new Color('#3B4134'));
//# sourceMappingURL=liquoriceBrandColors.js.map